/**
 * MediumIcons — SVG icon render functions for each painting medium.
 * Each takes a stroke color parameter and returns a 28×28 SVG.
 */

import type { ReactNode } from 'react';

export const MEDIUM_ICONS: Record<string, (color: string) => ReactNode> = {
  oil: (color) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <rect x="5" y="3" width="18" height="22" rx="2" stroke={color} strokeWidth="1.6" />
      <path d="M5 8h18" stroke={color} strokeWidth="1.2" />
      <path d="M9 13c0 0 2-2 5 0s5 0 5 0" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="11" cy="18" r="2" stroke={color} strokeWidth="1.2" fill={color} opacity="0.15" />
    </svg>
  ),
  acrylic: (color) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M8 24V10a2 2 0 012-2h8a2 2 0 012 2v14" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      <path d="M6 24h16" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 8V4l4 2v2" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="10" y="13" width="8" height="4" rx="1" fill={color} opacity="0.15" />
    </svg>
  ),
  watercolor: (color) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M14 4c0 0-6 7-6 12a6 6 0 0012 0c0-5-6-12-6-12z" stroke={color} strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M11 16c0 0 1.5-1 3 0s3 0 3 0" stroke={color} strokeWidth="1.2" strokeLinecap="round" opacity="0.5" />
    </svg>
  ),
  gouache: (color) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <rect x="7" y="6" width="14" height="18" rx="3" stroke={color} strokeWidth="1.6" />
      <rect x="10" y="10" width="8" height="6" rx="1.5" fill={color} opacity="0.15" />
      <path d="M12 3v3M16 3v3" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  pastel: (color) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <rect x="10" y="3" width="8" height="22" rx="4" stroke={color} strokeWidth="1.6" />
      <path d="M10 19h8" stroke={color} strokeWidth="1.2" opacity="0.4" />
      <ellipse cx="14" cy="7" rx="2.5" ry="1.5" fill={color} opacity="0.15" />
    </svg>
  ),
  mixed_media: (color) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <circle cx="10" cy="14" r="6" stroke={color} strokeWidth="1.4" />
      <circle cx="18" cy="14" r="6" stroke={color} strokeWidth="1.4" />
      <path d="M13 10.5a6 6 0 000 7" stroke={color} strokeWidth="1.2" opacity="0.3" />
      <circle cx="14" cy="14" r="2" fill={color} opacity="0.15" />
    </svg>
  ),
};
